/* ──────────────────────────────────────────────────────────────
   Socks Up — Lenis smooth scroll init
   Added 2026-06-03 overnight perf pass (Phase 2).

   Behaviour:
   - Smooth INERTIAL wheel scroll on desktop (subtle, buttery)
   - Native mobile scroll preserved (touch inertia is OS-best)
   - Respects prefers-reduced-motion (init skipped entirely)
   - Intercepts existing `window.scrollTo(...)` so the bundle stepper
     "scroll to top on step change" still works — but with Lenis easing.

   Interop notes:
   - Cart drawer: Lenis only handles document scroll, not inner-overflow
     scroll containers, so the drawer is untouched.
   - Sticky header: still works (position: sticky is browser-native).
   - GSAP ScrollTrigger (Phase 3): will be wired via lenis.on('scroll')
     when GSAP loads. For now, Lenis runs solo.
   ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // Skip Lenis entirely for users who want reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('su-no-lenis');
    return;
  }

  // Wait for Lenis to load (CDN script may be still loading)
  function init() {
    if (typeof Lenis !== 'function') {
      setTimeout(init, 50);
      return;
    }

    var lenis = new Lenis({
      lerp: 0.1,            // smoothing — 0.1 snappy, 0.05 silky. 0.1 = sweet spot for ecom
      duration: 1.0,        // duration of programmatic scrolls (s)
      smoothWheel: true,    // intercept mouse wheel
      smoothTouch: false,   // leave mobile native — OS inertia beats anything we do
      syncTouch: false,
      gestureOrientation: 'vertical',
      orientation: 'vertical',
      wheelMultiplier: 1,
      touchMultiplier: 1,
      infinite: false,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, // exponential ease-out
    });

    // Expose for any consumer (Phase 3 GSAP ScrollTrigger will need this)
    window.suLenis = lenis;

    // Drive Lenis via rAF — required so it actually animates
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Mark body so CSS can opt-in (e.g. fade-in once scroll is wired)
    document.documentElement.classList.add('su-lenis-active');

    // Pause Lenis when a modal opens (bundle quick-view, cart drawer overlay)
    // by listening for body class changes. Common pattern in the theme.
    var observer = new MutationObserver(function () {
      if (document.body.classList.contains('overflow-hidden') ||
          document.body.classList.contains('su-modal-open') ||
          document.documentElement.classList.contains('no-scroll')) {
        lenis.stop();
      } else {
        lenis.start();
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
